import Actions from "@/constants/store/actions";
import Mutations from "@/constants/store/mutations";
import store from "@/store/index";
import VehicleMake from "@/models/vehicle-make";
import VehicleYear from "@/models/vehicle-year";
import VehicleModel from "@/models/vehicle-model";
import VehicleTrim from "@/models/vehicle-trim";

export default {
    [Actions.fetch_taxonomies]({commit}) {
        return axios.get(`/web-api/taxonomy`, {
            params: {
                include: store.state.taxonomies.meta.include
            }
        })
            .then(response => {
                commit(Mutations.set_taxonomies, response);
                return response;
            })
    },
    [Actions.refresh_auth_user]({commit}) {
        return axios.get(`/web-api/account/current-user`, {
            params: {
                include: 'roles,companies'
            }
        })
            .then(response => {
                commit(Mutations.set_auth_user, response.data);
                return response;
            })
    },
    [Actions.fetch_vehicle_years]({commit}) {
        return VehicleYear
            .params({
                no_pagination: 1,
            })
            .get()
            .then((response) => {
                commit(Mutations.set_vehicle_years, response);
                return response;
            })
    },
    [Actions.fetch_vehicle_makes]({commit}) {
        return VehicleMake
            .include(store.state.vehicle_makes.meta.include)
            .params({
                no_pagination: 1,
            })
            .get()
            .then((response) => {
                commit(Mutations.set_vehicle_makes, response);
            })
    },
    [Actions.fetch_vehicle_models]({commit}) {
        return VehicleModel
            .include(store.state.vehicle_models.meta.include)
            .params({
                no_pagination: 1,
            })
            .get()
            .then((response) => {
                commit(Mutations.set_vehicle_models, response);
            })
    },
    [Actions.fetch_vehicle_trims]({commit}) {
        return VehicleTrim
            .include(store.state.vehicle_trims.meta.include)
            .params({
                no_pagination: 1,
            })
            .get()
            .then((response) => {
                commit(Mutations.set_vehicle_trims, response);
            })
    },
}
